module.exports = __webpack_public_path__ + "static/media/coverPhoto.a86c3781.png";